module.exports = "<div class=\"overlay\" (click)=\"closePopOver()\"></div>\r\n"